import { render, staticRenderFns } from "./blueSectionPortolio.vue?vue&type=template&id=0d6cb9f2&"
import script from "./blueSectionPortolio.vue?vue&type=script&lang=js&"
export * from "./blueSectionPortolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "blueSectionPortolio.vue"
export default component.exports